import React from 'react';
import { Modal, Typography, Space, Descriptions } from 'antd';

const { Text } = Typography;

interface ConfirmApprovalModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    loading: boolean;
    action: string;
    actionLabel: string;
    comment: string;
}

const ConfirmApprovalModal: React.FC<ConfirmApprovalModalProps> = ({
                                                                       open,
                                                                       onCancel,
                                                                       onConfirm,
                                                                       loading,
                                                                       action,
                                                                        actionLabel,
                                                                       comment
                                                                   }) => {
    return (
        <Modal
            title="Confirm Action"
            open={open}
            onCancel={onCancel}
            onOk={onConfirm}
            okText="Confirm"
            cancelText="Cancel"
            confirmLoading={loading}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                <Descriptions column={1}>
                    <Descriptions.Item label="Selected Action">
                        <Text strong>{actionLabel}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Comments">
                        <Text>{comment}</Text>
                    </Descriptions.Item>
                </Descriptions>
                <Text type="warning">
                    Are you sure you want to proceed with this action? This cannot be undone.
                </Text>
            </Space>
        </Modal>
    );
}

export default ConfirmApprovalModal;